import { useQuery } from "@tanstack/react-query";
import dashboardApi from "api/dashboard";

export const useGetDashboard = () => {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: () => dashboardApi.getDashboard(),
    // enabled: process.env.REACT_APP_ENV !== "stg",
  });
};

export const useGetDashboardGeneral = () => {
  return useQuery({
    queryKey: ["dashboardGeneral"],
    queryFn: () => dashboardApi.getDashboardGeneral(),
    // enabled: process.env.REACT_APP_ENV !== "stg",
  });
};

export const useGetDashboardPostComment = () => {
  return useQuery({
    queryKey: ["dashboardPostComment"],
    queryFn: () => dashboardApi.getDashboardPostComment(),
    // enabled: process.env.REACT_APP_ENV !== "stg",
  });
};
